import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Container } from "@mui/material";
import React from "react";
const SectionContainer = ({ children, backgroundColor, hasDarkBackground = false, sxContainer, }) => {
    return (_jsx(Box, { sx: {
            backgroundColor,
        }, "data-dark": hasDarkBackground || undefined, children: _jsx(Container, { sx: {
                py: { xs: "40px", md: "100px" },
                px: {
                    xs: "24px !important",
                    md: "40px !important",
                    lg: "72px !important",
                },
                "@media (min-width: 1440px)": {
                    px: "100px !important",
                },
                ...sxContainer,
            }, children: children }) }));
};
export default SectionContainer;
